import { observer } from 'mobx-react';
import { useRef } from 'react';
import { Link } from '../../../../../../../../../../Resource/Types';
import CopyToClipboardStore from '../../../../../../../../../CopyToClipboard/Store';
import CopyToClipboardReactions from '../../../../../../../../../CopyToClipboard/Store/Reactions';
import States from './States';

export interface Props {
  link: Link;
}

function CopyLinkButton({ link }: Props) {
  const copyToClipboardStore: CopyToClipboardStore = useRef(
    new CopyToClipboardStore(link.href),
  ).current;
  return (
    <>
      <States copyText={link.href} store={copyToClipboardStore} />
      <CopyToClipboardReactions store={copyToClipboardStore} />
    </>
  );
}

export default observer(CopyLinkButton);
